<template>
	<div class="col-3" v-if="$route.path==='/matches' || $route.path==='/favourites'">
	  <router-link :to="'user/' + userData.slug" class="profile-box">
	    <div class="image-profile">
	      <img :src="userData.profileimg">
        <div v-if="metadisplay" @click.stop.prevent="removeFavourite(userid)" class="btn-remove"></div>
        <div v-if="$route.path==='/matches'" @click.stop.prevent="removeMatch(userid)" class="btn-remove"></div>
	    </div>
	    <div class="info" :data-userid="userid">
	      <h5>{{ userData.firstname + ' ' + userData.surname }}</h5>
	      <!-- <p class="reputation">{{ userRep['.value'] }}</p> -->
	      <p>{{ userData.jobtitle }},&nbsp;{{ userData.organisation }}</p>
        <p class="small">Based in {{ userData.location }}</p>
	    </div>
<!--       <ul class="match-info" v-if="metadisplay">
        <li>
          <div class="image-circle">
            <img src="../assets/images/test-square.jpg">
          </div>
        </li>
        <li>
          <div class="image-circle">
            <img src="../assets/images/test-square.jpg">
          </div>
        </li>
        <li>
          <div class="image-circle">
            <img src="../assets/images/test-square.jpg">
          </div>
        </li>
        <li>
          <div class="image-circle">
            <img src="../assets/images/test-square.jpg">
          </div>
        </li>
        <li>
          <div class="image-circle">
            <img src="../assets/images/test-square.jpg">
          </div>
        </li>
        <li>
          <div class="image-circle">
            <img src="../assets/images/test-square.jpg">
          </div>
        </li>
      </ul> -->
	  </router-link>
	</div>


  <div class="col-2" v-else-if="$route.path==='/everyone'">
    <router-link :to="'user/' + userData.slug" class="profile-box small">
      <div class="image-profile">
        <img :src="userData.profileimg">
      </div>
      <div class="info" :data-userid="userid">
        <h5>{{ userData.firstname + ' ' + userData.surname }}</h5>
        <p class="small">{{ userData.jobtitle }},&nbsp;{{ userData.organisation }}</p>
      </div>
    </router-link>
  </div>


</template>

<script>
import { db } from '@/firebase'
export default {
  props: ['userid', 'metadisplay'],
  data () {
    return {
      userData: {},
      userRep: {}
    }
  },
  // firebase: function () {
  //   return {
  //     userData: {
  //       source: db.ref('users/' + this.userid),
  //       asObject: true
  //     },
  //     userRep: {
  //       source: db.ref('user-meta/reputation/' + this.userid),
  //       asObject: true
  //     }
  //   }
  // },
  methods: {
    removeFavourite (userid) {
      // Remove favourite
      db.ref('users/' + this.$root.user.uid + '/favourites/' + userid).remove()
    },
    removeMatch (userid) {
      db.ref('users/' + this.$root.user.uid + '/hidden-users').update({
        [this.userid]: true
      })
    }
  },
  created: function () {
    this.userData = {}
    this.userRep = {}
    this.$bindAsObject('userData', db.ref('users/' + this.userid))
    this.$bindAsObject('userRep', db.ref('user-meta/reputation/' + this.userid))
  },
  watch: {
    userData: function (val) {
      if (val.profileimg === 'default') {
        this.userData.profileimg = 'https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// UserBox.vue?6147f3c7